/**
 * Employee Web — `/me/tasks` section layout route.
 *
 * Parent layout for `/me/tasks` (list) and `/me/tasks/$id` (detail — the
 * notification deep-link target). Renders an <Outlet/> only; the screens live
 * in the child routes. Self-surface, no permission gate (the endpoint scopes
 * to the caller).
 */
import type { JSX } from "react";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/me/tasks")({
  staticData: { breadcrumb: { labelKey: "tasks:nav.myTasks" } },
  component: MeTasksRoute,
});

function MeTasksRoute(): JSX.Element {
  return <Outlet />;
}
